"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;
var warned = {};

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] != null) {
      var message = "'".concat(propName, "' property of '").concat(componentName, "' has been deprecated.\n").concat(explanation || '');

      if (!warned[message]) {
        console.warn(message);
        warned[message] = true;
      }
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}